<template>
  <div class="kt-portlet kt-portlet--mobile">
    <div class="kt-portlet__head">
      <div class="kt-portlet__head-label">
        <h3 class="kt-portlet__head-title">
          Stock Cover Days — Monthly Snapshot (Manual Ops)
        </h3>
      </div>
      <div class="kt-portlet__head-toolbar">
        <router-link to="/Monitoring/ScheduledJobs" class="btn btn-sm btn-clean btn-icon-sm">
          <i class="fa fa-arrow-left"></i> Scheduled Jobs
        </router-link>
      </div>
    </div>

    <div class="kt-portlet__body">
      <div class="alert alert-secondary" role="alert" style="font-size:13px">
        <b>รันงาน Monthly Snapshot ด้วยตนเอง</b> — สำหรับผู้ดูแล (MonitorEmail) เท่านั้น ·
        <b>Backfill</b> = ปิดรอบย้อนหลังเป็นช่วง · <b>Close Period</b> = ปิดรอบทีละเดือน ·
        <b>force</b> = re-close ทับเดือนที่ปิดแล้ว (คำนวณใหม่จาก Target/Jobs ปัจจุบัน · config ยัง frozen)
      </div>

      <div class="row">
        <!-- ============ Backfill ============ -->
        <div class="col-lg-6 mb-4">
          <div class="kt-portlet kt-portlet--height-fluid" style="border:1px solid #ebedf2">
            <div class="kt-portlet__head">
              <div class="kt-portlet__head-label">
                <h3 class="kt-portlet__head-title"><i class="fa fa-history text-primary"></i>&nbsp; Backfill (ช่วงเดือน)</h3>
              </div>
            </div>
            <div class="kt-portlet__body">
              <div class="form-group row">
                <label class="col-5 col-form-label">ตั้งแต่ (ปี / เดือน)</label>
                <div class="col-7 d-flex">
                  <input type="number" class="form-control mr-2" v-model.number="bf.fromYear" placeholder="ปี" />
                  <input type="number" class="form-control" v-model.number="bf.fromMonth" min="1" max="12" placeholder="1-12" />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-5 col-form-label">ถึง (ปี / เดือน)</label>
                <div class="col-7 d-flex">
                  <input type="number" class="form-control mr-2" v-model.number="bf.toYear" placeholder="ปี" />
                  <input type="number" class="form-control" v-model.number="bf.toMonth" min="1" max="12" placeholder="1-12" />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-5 col-form-label">force (re-close)</label>
                <div class="col-7">
                  <label class="kt-checkbox">
                    <input type="checkbox" v-model="bf.force" /> ทับเดือนที่ปิดแล้ว <span></span>
                  </label>
                </div>
              </div>
              <button class="btn btn-primary btn-block" :disabled="bf.running" @click="runBackfill">
                <i class="fa fa-play"></i> {{ bf.running ? "กำลังรัน..." : "รัน Backfill" }}
              </button>
              <small class="form-text text-muted mt-2">
                * ไม่ปิดเดือนปัจจุบัน/อนาคต (guard) · idempotent ถ้าไม่ติ๊ก force
              </small>
            </div>
          </div>
        </div>

        <!-- ============ Close Period ============ -->
        <div class="col-lg-6 mb-4">
          <div class="kt-portlet kt-portlet--height-fluid" style="border:1px solid #ebedf2">
            <div class="kt-portlet__head">
              <div class="kt-portlet__head-label">
                <h3 class="kt-portlet__head-title"><i class="fa fa-lock text-success"></i>&nbsp; Close Period (เดือนเดียว)</h3>
              </div>
            </div>
            <div class="kt-portlet__body">
              <div class="form-group row">
                <label class="col-5 col-form-label">ปี / เดือน</label>
                <div class="col-7 d-flex">
                  <input type="number" class="form-control mr-2" v-model.number="cp.year" placeholder="ปี" />
                  <input type="number" class="form-control" v-model.number="cp.month" min="1" max="12" placeholder="1-12" />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-5 col-form-label">force (re-close)</label>
                <div class="col-7">
                  <label class="kt-checkbox">
                    <input type="checkbox" v-model="cp.force" /> ทับถ้าปิดแล้ว <span></span>
                  </label>
                </div>
              </div>
              <button class="btn btn-success btn-block" :disabled="cp.running" @click="runClose">
                <i class="fa fa-lock"></i> {{ cp.running ? "กำลังรัน..." : "ปิดรอบเดือนนี้" }}
              </button>
              <small class="form-text text-muted mt-2">
                * ปิดได้เฉพาะเดือนที่จบแล้ว (guard เดือนปัจจุบัน/อนาคต)
              </small>
            </div>
          </div>
        </div>
      </div>

      <!-- ============ Period status ============ -->
      <div class="kt-portlet kt-portlet--height-fluid mt-2" style="border:1px solid #ebedf2">
        <div class="kt-portlet__head">
          <div class="kt-portlet__head-label">
            <h3 class="kt-portlet__head-title"><i class="fa fa-table"></i>&nbsp; สถานะ Period ({{ periods.length }})</h3>
          </div>
          <div class="kt-portlet__head-toolbar">
            <select class="form-control form-control-sm mr-2" v-model.number="periodYear" @change="loadPeriods" style="width:110px;display:inline-block">
              <option :value="0">ทุกปี</option>
              <option v-for="y in yearOptions" :key="y" :value="y">{{ y }}</option>
            </select>
            <button class="btn btn-sm btn-clean btn-icon-sm" @click="loadPeriods" :disabled="loading">
              <i class="fa fa-sync" :class="{ 'fa-spin': loading }"></i> รีเฟรช
            </button>
          </div>
        </div>
        <div class="kt-portlet__body">
          <div class="table-responsive">
            <table class="table table-sm table-striped table-bordered">
              <thead class="thead-light">
                <tr>
                  <th>ปี</th><th>เดือน</th><th>สถานะ</th>
                  <th class="text-right">snapshot rows</th><th>ปิดเมื่อ</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="periods.length === 0"><td colspan="5" class="text-center text-muted">— ยังไม่มี period ที่ปิด —</td></tr>
                <tr v-for="p in periods" :key="p.year + '-' + p.month">
                  <td>{{ p.year }}</td>
                  <td>{{ p.month }}</td>
                  <td><span class="badge" :class="p.status === 'CLOSED' ? 'badge-success' : 'badge-secondary'">{{ p.status }}</span></td>
                  <td class="text-right">{{ p.snapshotRowCount }}</td>
                  <td>{{ fmtDate(p.closedDate) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "MonitoringScvd",
  data() {
    var now = new Date();
    var prev = new Date(now.getFullYear(), now.getMonth() - 1, 1); // last completed month
    return {
      bf: { fromYear: 2025, fromMonth: 1, toYear: prev.getFullYear(), toMonth: prev.getMonth() + 1, force: false, running: false },
      cp: { year: prev.getFullYear(), month: prev.getMonth() + 1, force: false, running: false },
      periods: [],
      periodYear: now.getFullYear(),
      loading: false,
    };
  },
  computed: {
    yearOptions() {
      var y = new Date().getFullYear();
      return [y + 1, y, y - 1, y - 2];
    },
  },
  mounted() {
    this.loadPeriods();
  },
  methods: {
    fmtDate(d) {
      if (!d) return "-";
      try { return new Date(d).toLocaleString("th-TH"); } catch (e) { return d; }
    },
    validMonth(m) { return Number.isInteger(m) && m >= 1 && m <= 12; },

    loadPeriods() {
      this.loading = true;
      var params = {};
      if (this.periodYear) params.year = this.periodYear;
      axios.get("/Api/Monitor/scvd_periods", { params })
        .then((res) => { this.periods = (res.data && res.data.items) || []; })
        .catch((err) => {
          if (err.response && err.response.status === 403) { this.$router.push("/"); return; }
          console.error("loadPeriods", err);
        })
        .finally(() => { this.loading = false; });
    },

    runBackfill() {
      var b = this.bf;
      if (!b.fromYear || !b.toYear || !this.validMonth(b.fromMonth) || !this.validMonth(b.toMonth)) {
        Swal.fire("ข้อมูลไม่ครบ", "กรอกปี/เดือน (1-12) ให้ครบ", "warning");
        return;
      }
      var self = this;
      Swal.fire({
        title: "ยืนยันรัน Backfill",
        html: "ช่วง <b>" + b.fromYear + "-" + b.fromMonth + "</b> ถึง <b>" + b.toYear + "-" + b.toMonth + "</b>" +
              (b.force ? "<br><span style='color:#c0392b'>force = ON → ทับเดือนที่ปิดแล้ว (คำนวณใหม่)</span>" : ""),
        icon: "question", showCancelButton: true, confirmButtonText: "รัน", cancelButtonText: "ยกเลิก",
      }).then((r) => {
        if (!r.value) return;
        self.bf.running = true;
        axios.post("/Api/Monitor/scvd_backfill", null, {
          params: { fromYear: b.fromYear, fromMonth: b.fromMonth, toYear: b.toYear, toMonth: b.toMonth, force: b.force },
        }).then((res) => {
          var d = res.data || {};
          if (d.status === "SUCCESS") {
            var x = d.result || {};
            Swal.fire("สำเร็จ",
              "ปิด " + (x.monthsClosed || 0) + " · ข้าม " + (x.monthsSkipped || 0) +
              " · guard " + (x.monthsGuarded || 0) + " · rows " + (x.totalRows || 0), "success");
            self.loadPeriods();
          } else if (d.status === "FORBIDDEN") {
            self.$router.push("/");
          } else {
            Swal.fire("ไม่สำเร็จ", (d.result && d.result.message) || d.message || "error", "error");
          }
        }).catch((err) => {
          if (err.response && err.response.status === 403) { self.$router.push("/"); return; }
          Swal.fire("เกิดข้อผิดพลาด", (err.response && err.response.data && err.response.data.message) || err.message, "error");
        }).finally(() => { self.bf.running = false; });
      });
    },

    runClose() {
      var c = this.cp;
      if (!c.year || !this.validMonth(c.month)) {
        Swal.fire("ข้อมูลไม่ครบ", "กรอกปี/เดือน (1-12) ให้ครบ", "warning");
        return;
      }
      var self = this;
      Swal.fire({
        title: "ยืนยันปิดรอบ",
        html: "เดือน <b>" + c.year + "-" + c.month + "</b>" +
              (c.force ? "<br><span style='color:#c0392b'>force = ON → ทับถ้าปิดแล้ว</span>" : ""),
        icon: "question", showCancelButton: true, confirmButtonText: "ปิดรอบ", cancelButtonText: "ยกเลิก",
      }).then((r) => {
        if (!r.value) return;
        self.cp.running = true;
        axios.post("/Api/Monitor/scvd_close_period", null, {
          params: { year: c.year, month: c.month, force: c.force },
        }).then((res) => {
          var d = res.data || {};
          if (d.status === "SUCCESS") {
            var x = d.result || {};
            Swal.fire(x.skipped ? "ข้าม (ปิดอยู่แล้ว)" : "สำเร็จ", x.message || "ปิดรอบสำเร็จ", x.skipped ? "info" : "success");
            self.loadPeriods();
          } else if (d.status === "FORBIDDEN") {
            self.$router.push("/");
          } else {
            Swal.fire("ไม่สำเร็จ", (d.result && d.result.message) || d.message || "error", "error");
          }
        }).catch((err) => {
          if (err.response && err.response.status === 403) { self.$router.push("/"); return; }
          Swal.fire("เกิดข้อผิดพลาด", (err.response && err.response.data && err.response.data.message) || err.message, "error");
        }).finally(() => { self.cp.running = false; });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// App/Components/Monitoring/MonitoringScvd.vue